import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _typeof from "@babel/runtime/helpers/esm/typeof";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'combobox-value-options',
  props: {
    value: null,
    disabled: {
      type: Boolean
    }
  },
  emits: ['input'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var optionSearch = ref(null);
    var optionsArray = computed(function () {
      if (!props.value || !props.value.options) {
        return [];
      }
      // Extract text values from options array
      // Options can be objects with { text, value, score } or just strings
      return props.value.options.map(function (opt) {
        if (typeof opt === 'string') {
          return opt;
        }
        return opt.text || opt.value || opt;
      });
    });
    var handleInput = function handleInput(options) {
      // Convert string array back to options format
      // Preserve existing structure if options had objects with value/score
      var newOptions = options.map(function (opt) {
        var _props$value, _props$value$options;
        // Check if this option existed before with additional properties
        var existing = (_props$value = props.value) === null || _props$value === void 0 ? void 0 : (_props$value$options = _props$value.options) === null || _props$value$options === void 0 ? void 0 : _props$value$options.find(function (o) {
          if (typeof o === 'string') {
            return o === opt;
          }
          return o.text === opt || o.value === opt;
        });

        // If it existed with additional properties, preserve them
        if (existing && _typeof(existing) === 'object') {
          return _objectSpread(_objectSpread({}, existing), {}, {
            text: opt,
            value: existing.value || opt
          });
        }
        return {
          text: opt
        };
      });
      var updatedValueOptions = _objectSpread(_objectSpread({}, props.value || {}), {}, {
        options: newOptions
      });
      emit('input', updatedValueOptions);
    };
    return {
      __sfc: true,
      props: props,
      emit: emit,
      optionSearch: optionSearch,
      optionsArray: optionsArray,
      handleInput: handleInput
    };
  }
});